<template>
    <div class="LeftPanel">
        <div class="LeftPanel-top">
            <div class="commontitle">
                <div class="imgBox">
                    <img src="@/assets/images/msgt/titleIcon.png" />
                </div>
                <p>用能趋势</p>
            </div>
            <div class="content">
                <div class="content-left">
                    <div class="name">今日用电/水/气</div>
                    <div class="value">22,214<span class="unit">kw·h</span></div>
                    <div class="rate">
                        <div class="rateName">同日比</div>
                        <div class="rateValue">+1.2%</div>
                    </div>
                </div>
                <div class="content-right">
                    <PublicEcharts :key="keyEcharts" :id="'TopLeftContent'" :chartsData="growthData" :type="'darkLine'"
                        :options="options" />
                </div>
            </div>
        </div>
        <div class="LeftPanel-bottom">
            <div class="commontitle">
                <div class="imgBox">
                    <img src="@/assets/images/msgt/titleIcon.png" />
                </div>
                <p>平台建设</p>
            </div>
            <div class="content">
                <div class="content-top">
                    <TopCharts />
                </div>
                <div class="content-center">
                    <div v-for="v, i in centerList" :key="i">
                        <div class="value" :style="{ color: v.color }">{{ numberToCurrencyNo(v.value) }}</div>
                        <div class="name">{{ v.name }}</div>
                    </div>
                </div>
                <div class="content-bottom">
                    <BottomCharts />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
import { numberToCurrencyNo } from "@/assets/js/utils";
import TopCharts from "./TopCharts";
import BottomCharts from "./BottomCharts";
export default {
    name: "LeftPanel",
    props: {},
    components: { PublicEcharts, TopCharts, BottomCharts },
    data() {
        return {
            growthData: {
                "unit": "万kw·h", "xData": ["01", "02", "03", "04", "05"],
                "dataArr": [{ "name": "2023", "data": ["4.05", "7.34", "11.82", "8.14", "9.92"] },
                { "name": "2022", "data": ["6.12", "6.29", "10.50", "11.10", "8.65"] }]
            },
            options: {
                legend: {
                    show: true,
                    textStyle: {
                        color: "#fff",
                    },
                    right: "2%",
                    top: "2%",
                },
                grid: {
                    top: "40px",
                    left: "50px",
                    right: "15px",
                    bottom: "30px",
                },
                yAxis: [
                    {
                        type: "value",
                        name: "单位:万kw·h",
                        nameTextStyle: {
                            color: "#82AFC6",
                            fontSize: 10,
                            padding: [0, 0, 0, -30],
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },

                        axisLabel: {
                            color: "rgb(116,166,181)",
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#0F2766",
                            },
                        },
                        max: function (value) {
                            if (value.max < 0) {
                                return Math.ceil(value.max +2);
                            }
                        },
                        min: function (value) {
                            if (value.min > 0) {
                                return Math.floor(value.min -1);
                            }
                        },
                    },
                ],
            },
            keyEcharts: 1,
            centerList: [{
                name: '完成建设单位/个',
                value: 11,
                color: '#A2E1FF'
            }, {
                name: '建筑数量/栋',
                value: 37,
                color: '#39E4EA'
            }, {
                name: '改造面积/m³',
                value: 124000,
                color: '#C7BB34'
            }, {
                name: '覆盖人数/人',
                value: 23000,
                color: '#74AE8B'
            }]
        }
    },
    computed: {},
    methods: {
        numberToCurrencyNo
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.LeftPanel {
    width: 100%;
    height: 100%;

    .commontitle {
        width: 100%;
        height: 36px;
        background: url("~@/assets/images/msgt/smartLeftTitleBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        @include setFlexStart;

        .imgBox {
            margin: 0 6px 0 30px;
        }

        p {
            color: #dfe6ee;
            font-weight: bold;
            font-size: 16px;
        }
    }

    &-top {
        height: 240px;

        .content {
            width: calc(100% - 16px);
            height: 204px;
            background: url("~@/assets/images/msgt/userContent.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include setFlexAround;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #A1A7B8;
            padding-left: 16px;

            // padding-top: 3px;
            // position: relative;
            // top: -3px;

            &-left {
                width: 120px;

                .name {
                    width: 112px;
                    height: 16px;
                    font-size: 14px;
                    color: #E0E3E8;
                    line-height: 16px;
                }

                .value {
                    width: 99px;
                    height: 26px;
                    font-size: 24px;
                    font-weight: 600;
                    color: #16E9F4;
                    line-height: 26px;
                    margin-top: 8px;
                }

                .unit {
                    width: 33px;
                    height: 14px;
                    line-height: 14px;
                    font-size: 14px;
                    color: #A1A7B8;
                    margin-left: 5px;
                }

                .rate {
                    margin-top: 8px;
                    @include setFlexCenter;
                    font-size: 12px;
                    height: 12px;
                    line-height: 12px;

                    .rateName {
                        width: 42px;
                    }

                    .rateValue {
                        margin-left: 5px;
                        width: 40px;
                        color: #FFFFFF;
                    }
                }
            }

            &-right {
                width: 300px;
                height: 190px;
            }
        }
    }

    &-bottom {
        margin-top: 16px;
        height: calc(100% - 256px);
        // height: 477px;

        .content {
            width: calc(100% - 32px);
            height: calc(100% - 36px);
            // height: 441px;
            background: url("~@/assets/images/msgt/userContent.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include setFlexBetween;
            flex-direction: column;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #A1A7B8;
            padding-left: 16px;
            padding-right: 16px;

            // padding-top: 3px;
            // position: relative;
            // top: -3px;

            &-top {
                width: 100%;
                height: calc(50% - 48px);
                // height: 170px;
            }

            &-center {
                width: 100%;
                height: 80px;
                margin: 8px 0;
                border: 1px solid #629CDF;
                @include setFlexAround;

                &>div {
                    width: 100px;
                    height: 100%;
                    @include setFlexCenter;
                    flex-direction: column;

                    .name {
                        margin-top: 5px;
                        height: 15px;
                        font-size: 13px;
                        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                        line-height: 15px;
                        color: #A1AFBA;
                    }

                    .value {
                        height: 24px;
                        font-size: 24px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        line-height: 24px;
                    }
                }
            }

            &-bottom {
                width: 100%;
                height: calc(50% - 48px);
                // height: 170px;
            }
        }
    }
}
</style>